import Dexie from 'dexie';

const VISITOR_SEGMENTS_DB_NAME = 'adaptive-content-visitor-segments';

const visitorSegmentsDb = new Dexie(VISITOR_SEGMENTS_DB_NAME);

visitorSegmentsDb.version(2).stores({
    segments: '++id, title',
});

export { visitorSegmentsDb };
